import { ConnectionTypeDocumentModel } from "./ConnectionTypeDocument.model";
import { RequestStatusProcess } from "./RequestStatusProcess";

export class AgencyRequiredDocumentModel {
    
    Id : number;
    IdRequest : number;
    RequestCode : string;
    AgencyNit : string;
    IdConnectionType : number;
    IdConnectionTypeDocument : number;
    FileName : string;
    FileUrl : string;
    StateWallet : string;
    StateProduct : string;
    DocumentStatus : boolean;
    ReviewDocument : boolean;
    CreatedBy : string;
    CreatedDate : Date;
    ModifiedBy : string;
    ModifiedDate : Date;
    IdRequiredDocument: number
    RequestStatusProcessDocument: RequestStatusProcess[];
    IdRequiredDocumentNavigation: ConnectionTypeDocumentModel;
  }
  